export enum CustomHeaderAction {
  Duplicate = `duplicate-dashboard`,
  ExportEmail = `export-email`,
  ExportSlack = `export-slack`,
  Move = `move`,
  PinDashboard = `pin-dashboards`,
  TV = `tv`,
}

export enum DefaultRoutePath {
  Discover = `discover`,
  Home = `home`,
}
